<template>
  <b-modal id="rename-tree-item-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ modalTitle }}</span>
      </div>
    </template>

    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!isLoading">
      <div class="form-group row">
        <label for="name_ru" class="col-md-3 col-form-label text-md-left apd-p adp-p__grey">{{ $t('voc.russian') }}</label>
        <div class="col-md-9">
          <input id="name_ru" type="text" class="adp-input" name="name_ru" autofocus v-model="nameRu">
        </div>
      </div>
      <div class="form-group row">
        <label for="name_en" class="col-md-3 col-form-label text-md-left apd-p adp-p__grey">{{ $t('voc.english') }}</label>
        <div class="col-md-9">
          <input id="name_en" type="text" class="adp-input" name="name_en" autofocus v-model="nameEn">
        </div>
      </div>
      <div class="form-group row">
        <label for="name_fr" class="col-md-3 col-form-label text-md-left apd-p adp-p__grey">{{ $t('voc.french') }}</label>
        <div class="col-md-9">
          <input id="name_fr" type="text" class="adp-input" name="name_fr" autofocus v-model="nameFr">
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="rename()"
          :disabled="nameRu.length < 2 || nameEn.length === 1 || nameFr.length === 1">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "RenameTreeItemModal",
  components: {
  },
  props: {
    treeItem: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isLoading: false,

      nameRu: '',
      nameEn: '',
      nameFr: '',
    }
  },
  computed: {
    modalTitle() {
      if (this.treeItem.type === 'group') return this.$t('admin.rename_group');
      if (this.treeItem.type === 'function') return this.$t('admin.rename_function');
      if (this.treeItem.type === 'competence') return this.$t('admin.rename_competence');
      if (this.treeItem.type === 'skill') return this.$t('admin.rename_skill');
    }
  },
  watch: {

  },
  methods: {
    onShow() {
      this.isLoading = true;

      this.nameRu = this.treeItem.title;
      this.nameEn = this.treeItem.name_en;
      this.nameFr = this.treeItem.name_fr;

      this.isLoading = false;
    },
    rename() {
      const itemId = this.treeItem.id;
      const data = {
        'id': itemId,
        'name_ru': this.nameRu,
        'name_en': this.nameEn ? this.nameEn : this.nameRu,
        'name_fr': this.nameFr ? this.nameFr : (this.nameEn ? this.nameEn : this.nameRu),
      };

      this.$emit('data-changed', data, this.treeItem);
    }
  },
  async mounted() {

  }
}
</script>
